import { AfterViewInit, Component, EventEmitter, inject, Input, OnInit, Output, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormField, MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { CountryVm } from '../../../core/models/country-vm';
import { Router, ActivatedRoute } from '@angular/router';
import { CartService } from '../../../core/services/cart/cart.service'; 
import { MatBadgeModule } from '@angular/material/badge';
@Component({
  selector: 'app-filter',
  standalone: true,
  imports: [MatIconModule,MatBadgeModule, CommonModule,FormsModule, MatSelectModule, MatFormFieldModule, MatInputModule],
  templateUrl: './filter.component.html',
  styleUrl: './filter.component.scss'
})
export class FilterComponent {
  @Output() filters = new EventEmitter<{  countryIsoCode: string }>();
  @Output() cartClick = new EventEmitter<string>();
  totalItem : number=0;
  protected router = inject(Router);
  protected cartService = inject(CartService);
  @Input({ required: true }) countryList!: CountryVm[];
  @Input() selectedCountryIsoCode: string = '';
  applyFilters( countryIsoCode: string): void {
    this.filters.emit({
      countryIsoCode: countryIsoCode,
      
    });
    localStorage.setItem('country', countryIsoCode);
  }
  ngOnInit(): void {
    this.cartService.getProducts()
    .subscribe(res=>{
      this.totalItem = res.length;
    })
  }
  cart(): void {
      this.cartClick.emit();
    } 
   
}
